import { render } from "./InspectorComp.vue?vue&type=template&id=9ecfe8b6&scoped=true"
import script from "./InspectorComp.vue?vue&type=script&lang=js"
export * from "./InspectorComp.vue?vue&type=script&lang=js"

import "./InspectorComp.vue?vue&type=style&index=0&id=9ecfe8b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ecfe8b6"]])

export default __exports__